import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class FullYearDateRangeModule {
}
FullYearDateRangeModule.ɵfac = function FullYearDateRangeModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FullYearDateRangeModule)(); };
FullYearDateRangeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FullYearDateRangeModule });
FullYearDateRangeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
